<template>
    <div>
        <h6 v-if="(profileId == 0)" class="heading-small text-muted mb-4">Add New Supercard Format {{ (supercardFormat.name) ? (" - " + supercardFormat.name) : "" }}</h6>
        <h6 v-else-if="profileId != 0 && this.$attrs.viewMode == true" class="heading-small text-muted mb-4">View Supercard Type - {{supercardFormat.name}}</h6>
        <h6 v-else class="heading-small text-muted mb-4">Edit Supercard Type - {{supercardFormat.name}}</h6>
        
        <base-alert v-if="errors.length" type="danger">
            <b>You have the following error(s):</b>
            <li v-for="error in errors" :key="error">{{ error }}</li>
        </base-alert>

        <b-tabs v-show="profileId != 0 && this.$attrs.viewMode == true" content-class="mt-3">
            <b-tab title="Details" active v-on:click="openDetails"></b-tab>
            <b-tab title="History" v-on:click="openHistory" :disabled="loading">
                <b><label>Created By: </label></b>
                {{ createdBy }} | {{ createdAt | dateFilter }}
                <br>
                <b><label>Updated By:</label></b>
                {{ updatedBy }} | {{ updatedAt | dateFilter }}
                <div class="card shadow">
                    <a-table :columns="supercardFormatUpdateHistoryColumns" :dataSource="supercardFormatUpdateHistoryData"
                        :loading="loading" :pagination="pagination" bordered>
                    </a-table>
                </div>
            </b-tab>
        </b-tabs>

        <form id="form-proper">
            <div v-if="customFormMode == 1" v-show="showDetails">
                <base-input alternative="" label="Code" placeholder="" v-model="supercardFormat.code" input-classes="form-control" />
                <base-input alternative="" label="Name" placeholder="" v-model="supercardFormat.name" input-classes="form-control" required />
                <base-input alternative="" label="Remark">
                    <textarea rows="4" class="form-control" v-model="supercardFormat.remark" />
                </base-input>

                <!-- Enable Replenishment -->
                <div class="form-group">
                    <label class="form-control-label">
                        Enable Replenishment
                    </label>

                    <div>
                        <label class="custom-toggle">
                            <input
                                type="checkbox"
                                v-model="supercardFormat.enable_replenishment"
                                :disabled="$attrs.viewMode"
                            >
                            <span class="custom-toggle-slider rounded-circle"></span>
                        </label>
                    </div>
                </div>

                <!-- Enable Welcome Discount -->
                <div class="form-group">
                    <label class="form-control-label">
                        Enable Welcome Discount
                    </label>

                    <div>
                        <label class="custom-toggle">
                            <input
                                type="checkbox"
                                v-model="supercardFormat.enable_welcome_discount"
                                :disabled="$attrs.viewMode"
                            >
                            <span class="custom-toggle-slider rounded-circle"></span>
                        </label>
                    </div>
                </div>
            </div>

            <div v-if="customFormMode == 2">
                <dynamic-form :convertedJson="{mode: customForm.mode, groups: customForm.groups}" :formSettings="supercardFormat" @valueUpdated="updateSettings" :key="dynamicFormKey"/>
            </div>

            <div v-if="customFormMode == 3">
                <a-tabs defaultActiveKey="1">
                    <a-tab-pane tab="Basic" key="1">
                        <base-input alternative="" label="Code" placeholder="" v-model="supercardFormat.code" input-classes="form-control" />
                        <base-input alternative="" label="Name" placeholder="" v-model="supercardFormat.name" input-classes="form-control" required />
                        <base-input alternative="" label="Remark">
                            <textarea rows="4" class="form-control" v-model="supercardFormat.remark" />
                        </base-input>
                    </a-tab-pane>
                    <a-tab-pane tab="Custom Fields" key="2" forceRender>
                        <dynamic-form :convertedJson="{mode: customForm.mode, groups: customForm.groups_append}" :formSettings="supercardFormat" @valueUpdated="updateSettings" :key="dynamicFormKey" :showErrors="false"/>
                    </a-tab-pane>
                </a-tabs>
            </div>
            
            <div v-if="this.$attrs.viewMode != true">
                <div v-if="serverType == 'ho'" style="position: absolute;bottom: 0px;right: 0px;width: -webkit-fill-available;background-color: #f2f2f2 ;padding: 10px;">
                    <button v-if="(profileId == 0)" type="button" class="btn btn-primary float-right" @click.prevent="create">Create</button> 
                    <button v-else type="button" class="btn btn-primary float-right" @click.prevent="update">Update</button>
                </div>
                <div v-else style="position: absolute;bottom: 0px;right: 0px;width: -webkit-fill-available;background-color: #f2f2f2 ;padding: 10px;">
                    <button type="button" class="btn btn-primary float-right" @click.prevent="$emit('closeDrawer', null)">Close</button> 
                </div>
            </div>
        </form>
    </div>
</template>


<script>
    import HTTPRequest from '../../controllers/httpRequest.js'
    import ValidateField from '../../components/validateFormUtils.js'
    import { mapState } from 'vuex'
    import DynamicForm from '../DynamicForm.vue'
    import moment from 'moment'

    var component_x;
    export default {
        components: {
            DynamicForm
        },
        computed: {
            ...mapState(['endPoint', 'profileId', 'serverType']),
        },
        mounted: async function () {

            // Meta-data Call
            const sytemModule = await HTTPRequest.getRequest(this.endPoint + 'system_modules/Supercard Types?field_name=name'  , null)
            const sytemModuleId = sytemModule.id
            const accSystemModuleRequest = await HTTPRequest.getRequest(this.endPoint + 'account_system_modules/' + sytemModuleId + '?field_name=system_module_id'  , null)
            if(this.isJsonString(accSystemModuleRequest.meta) == true){ 
                const accSystemModule = JSON.parse(accSystemModuleRequest.meta)
                if(accSystemModule != null){
                    if(accSystemModule.form_mode != undefined){
                        this.customFormMode = accSystemModule.form_mode
                    }
                    if(accSystemModule.customized_forms != undefined){
                        this.customForm = accSystemModule.customized_forms
                    }
                }
            }

            if(this.serverType == 'branch' || this.$attrs.viewMode == true){
                var form = document.getElementById("form-proper")
                var elements = form.elements;
                for (var i = 0, len = elements.length; i < len; ++i) {
                    elements[i].readOnly = true;
                }
            }
            component_x = this
            if (component_x.profileId > 0) {
                var supercard_format_data = await HTTPRequest.getRequest(component_x.endPoint + 'supercard_formats/' + component_x.profileId, null)
                if (supercard_format_data == undefined) {
                    component_x.$router.go()
                } else {
                    if (supercard_format_data["error"] == undefined) {
                        component_x.supercardFormat = supercard_format_data
                        component_x.createdBy = supercard_format_data.created_by
                        component_x.updatedBy = supercard_format_data.updated_by
                        component_x.createdAt = supercard_format_data.created_at
                        component_x.updatedAt = supercard_format_data.updated_at
                    } else {
                        this.errors = supercard_format_data["error"].split(",")
                    }
                }
            }

            this.dynamicFormKey++;
            this.loading = false
        },
        data: function () {
            return {
                errors: [],
                // FOR META-DATA
                customFormMode: 1,
                customForm: {},
                profileData: {},
                dynamicFormKey: 0,
                supercardFormat: {
                    code: '',
                    name: '',
                    enable_replenishment: false,
                    enable_welcome_discount: false
                },
                formErrors: [],
                createdAt: '',
                updatedAt: '',
                createdBy: '',
                updatedBy: '',
                supercardFormatUpdateHistoryColumns: [
                    { title: "Action", dataIndex: "action", key: "action" },
                    { title: "Field Name", dataIndex: "field_name", key: "field_name" },
                    { title: "From", dataIndex: "old_value", key: "old_value" },
                    { title: "To", dataIndex: "new_value", key: "new_value" },
                    { title: "Created By/Updated By", dataIndex: "updated_by", key: "updated_by" },
                    // { title: "Updated At", dataIndex: "updated_at", key: "updated_at" },
                    { title: "Created At/Updated At", dataIndex: "formatted_updated_at", key: "updated_at" },
                ],
                supercardFormatUpdateHistoryData: null,
                loading: true,
                pagination: false,
                showDetails: true
            }
        },
        filters: {
            dateFilter: function (timestamp) {
                return moment(timestamp).format('L LTS')
            }
        },
        methods: {
            updateSettings(newFormSettings, settingsGrouping, errors){
                var formSettingsCopy = this.supercardFormat
                var mergedHash = Object.assign({}, formSettingsCopy, newFormSettings);
                this.formErrors = errors

                if(this.customFormMode == 3) {
                    this.errors = errors
                }

                this.supercardFormat = mergedHash
            },
            isJsonString(str) {
                try {
                    var json = JSON.parse(str);
                    return (typeof json === 'object');
                } catch (e) {
                    return false;
                }
            },

            validateForm(){
                this.errors = [];
                // this.errors.push(ValidateField.required('Code', this.supercardFormat.code));
                // this.errors.push(ValidateField.alphanumericWithSpecialChars('Code', this.supercardFormat.code));
                this.errors.push(ValidateField.charMinAndMax('Code', this.supercardFormat.code, 0, 30));
                this.errors.push(ValidateField.required('Name', this.supercardFormat.name));
                // this.errors.push(ValidateField.alphanumericWithSpecialChars('Name', this.supercardFormat.name));
                this.errors.push(ValidateField.charMinAndMax('Name', this.supercardFormat.name, 0, 50));
                this.errors = this._.compact(this.errors);
                document.getElementsByClassName('ant-drawer-wrapper-body')[0].scrollTop = 0;
                return this.errors.length;
            },
            create: async function () {
                if(!this.validateForm()) {
                    // var supercardFormatPayload = {
                    //     supercard_format: {
                    //         name: this.inputName.trim(),
                    //         code: this.inputCode.trim(),
                    //         remark: this.inputRemark,
                    //         status: 'A',
                    //         operation_type: this.inputOperation
                    //     }
                    // }
                    this.supercardFormat.name = this.supercardFormat.name.trim()
                    this.supercardFormat.code = this.supercardFormat.code.trim()
                    this.supercardFormat.status = 'A'
                    var supercardFormatPayload = { supercard_format: this.supercardFormat }

                    var post_request = await HTTPRequest.postRequest(this.endPoint + 'supercard_formats', null, supercardFormatPayload)
                    if (post_request == undefined) {
                        this.$emit('refreshPage', event)
                    } else {
                        if (post_request["error"] == undefined) {
                            this.$emit('refreshPage', event)
                        } else {
                            this.errors = post_request["error"].split(",")
                        }
                    }
                }
            },
            update: async function () {
                if(!this.validateForm()) {
                    // var supercardFormatPayload = {
                    //     supercard_format: {
                    //         name: this.inputName.trim(),
                    //         code: this.inputCode.trim(),
                    //         remark: this.inputRemark,
                    //         status: 'A',
                    //         operation_type: this.inputOperation
                    //     }
                    // }

                    this.supercardFormat.name = this.supercardFormat.name.trim()
                    this.supercardFormat.code = this.supercardFormat.code.trim()
                    let status = (this.supercardFormat.status == null) ?  "A" : this.supercardFormat.status
                    this.supercardFormat.status = status
                    // this.supercardFormat.status = 'A'
                    var supercardFormatPayload = { supercard_format: this.supercardFormat }

                    var put_request = await HTTPRequest.putRequest(this.endPoint + 'supercard_formats/' + this.profileId, null, supercardFormatPayload)
                    if (put_request == undefined) {
                        this.$emit('refreshPage', event)
                    } else {
                        if (put_request["error"] == undefined) {
                            this.$emit('refreshPage', event)
                        } else {
                            this.errors = put_request["error"].split(",")
                        }
                    }
                }
            },
            openDetails() {
                this.showDetails = true
            },
            async openHistory() {
                this.showDetails = false
                var supercardFormatUpdateHistoryData = await HTTPRequest.getRequest(
                    this.endPoint +
                    "supercard_format_update_histories?supercard_format_id=" +
                    this.supercardFormat.id,
                    null,
                    null
                );
                this.supercardFormatUpdateHistoryData = supercardFormatUpdateHistoryData;
            },
        }
    }
</script>

<style>
</style>